import { ImpressionEvent } from '@moonpig/web-core-analytics'

export const createPromotionImpressionGAEvent = (
  uiComponent: string,
  title: string,
  experimentVariantName: string,
): ImpressionEvent => {
  return {
    event: 'impression',
    content_data: {
      content_type:
        `promotion | view promotion | ${uiComponent} | ${title}`.toLocaleLowerCase(),
      item_id: experimentVariantName.toLocaleLowerCase(),
    },
    // For GA3 backward compatibility
    event_data: {
      category: 'promotion',
      action: 'view promotion',
      label:
        `${uiComponent} | ${experimentVariantName} | ${title}`.toLocaleLowerCase(),
      non_interaction: true,
      value: undefined,
    },
  }
}
